import createCustomApp from '@/views/init-app.js';
import MainPage from '@/views/DataportalOverview.vue';

const domId = 'data-portal-list';

createCustomApp(MainPage, domId);
